import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import userSettingEnum from '../../../constants/enums/user-setting-enum';
import { useStore } from '../../../contexts/store-provider';
import {
  getTenantAccessFromLocalStorage,
  getTenantIdFromLocalStorage,
} from '../../../helpers/localstorage-helper';
import { IFormModalProps } from '../../../models/forms/IForm';
import { IReactSelectOption } from '../../../models/ICommon';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import ProcessReorderForm from '../forms/process-reorder-form';
import productStore from '../../../core/stores/product-store';

interface IProps extends IFormModalProps {
  processOptions: IReactSelectOption[];
  onSubmitReorder?: () => void;
  isDimension?: boolean;
}

const ProcessReorder = (props: IProps) => {
  const { activeTrayManagementStore, processStore, dimensionStore } =
    useStore();
  const {
    GetAllProcessService,
    allFactoryProcess,
    setCheckedColumns,
    getAllProcessState,
  } = processStore;
  const { GetDimensionListService, allDimension, getDimensionState } =
    dimensionStore;

  const {
    SaveProcessOrderService,
    saveProcessOrderState,
    resetSaveProcessOrderState,
  } = activeTrayManagementStore;
  const { GetDimensionColumnService, getDimensionTableColumnKeys } =
    productStore;

  useEffect(() => {
    if (props.isDimension) {
      GetDimensionColumnService(getTenantAccessFromLocalStorage());
    } else {
      GetAllProcessService(
        Number(getTenantIdFromLocalStorage()),
        userSettingEnum.HideProcessInActiveTray
      );
    }
  }, [props.isDimension]);

  useEffect(() => {
    if (saveProcessOrderState.error) {
      toast.error(formatMessage(saveProcessOrderState.error));
      resetSaveProcessOrderState();
    }
  }, [saveProcessOrderState.error]);

  const onSubmitForm = (values: any) => {
    setCheckedColumns(
      values.map((item: any) => ({
        ShortName: item.shortName,
        IsHidden: item.IsHidden,
      }))
    );
    const payload = values.map((value: any) => value.id).join(',');
    SaveProcessOrderService({
      SettingKey: props.isDimension
        ? `${userSettingEnum.DimensionColumnOrder}-${getTenantIdFromLocalStorage()}`
        : userSettingEnum.OperatorTaskOrder,
      ProcessOrder: payload,
      HideSettingKey: props.isDimension
        ? ''
        : userSettingEnum.HideProcessInActiveTray,
      ProcessId: props.isDimension
        ? ''
        : values
            .filter((item: any) => item.IsHidden)
            .map((value: any) => value.id)
            .join(','),
    });
    // localStorage.setItem('process_order', payload);
    props.onSubmitReorder && props.onSubmitReorder();
    props.modalClosed();
  };

  const onModalClosed = () => {
    props.modalClosed();
  };

  const dataList = props.isDimension
    ? getDimensionTableColumnKeys
    : allFactoryProcess;
  const isLoading = props.isDimension
    ? productStore.getDimensionColumnState.inProgress
    : getAllProcessState.inProgress;

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className=""
        addHeader="reorder_process"
        updateHeader="reorder_process"
        onModalClosed={onModalClosed}
        isLoading={isLoading}
        // size="sm"
      >
        <ProcessReorderForm
          id={-1}
          initialValues={{ processOrder: props.processOptions }}
          isLoading={isLoading}
          onModalClosed={onModalClosed}
          submitHandler={onSubmitForm}
          processOrder={dataList}
          isDimension={props.isDimension}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(ProcessReorder);
